import React from 'react';
import { HSIconType } from '@types';
import { Collapse } from '@components/Collapse';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import IconSettingImage from '@modules/panel/PanelHotspot/IconSetting/IconSettingImage';
import IconSettingMark from '@modules/panel/PanelHotspot/IconSetting/IconSettingMark';
import IconSettingPolygon from '@modules/panel/PanelHotspot/IconSetting/IconSettingPolygon';
import IconSettingSeqFrame from '@modules/panel/PanelHotspot/IconSetting/IconSettingSeqFrame';
import IconSettingSystem from '@modules/panel/PanelHotspot/IconSetting/IconSettingSystem';
import IconSettingVideo from '@modules/panel/PanelHotspot/IconSetting/IconSettingVideo';
import { reAddEditingHotspot } from '@modules/hotspot/actions';
import hotspotIconDefault from '@modules/hotspot/utils/hotspotIconDefault';
import { $editingHotspotApi } from '@stores/editingHotspotStores';

const items: DropdownItem<HSIconType | 'none'>[] = [
  { id: 'none', name: '保持原有样式' },
  { id: HSIconType.system, name: '系统图标' },
  { id: HSIconType.mark, name: '文字标记' },
  { id: HSIconType.image, name: '图片' },
  { id: HSIconType.seqFrame, name: '序列帧' },
  { id: HSIconType.video, name: '视频' },
];

interface Props {
  onChange: (typeId: HSIconType | 'none') => void;
}

function IconBatchSetting({ onChange }: Props) {
  const [icon, setIcon] = React.useState<HSIconType | 'none'>('none');

  const handleIconTypeChange = (typeId: HSIconType) => {
    const newIcon = hotspotIconDefault({
      type: typeId,
    });
    $editingHotspotApi.update((draft) => {
      draft.icon = newIcon;
      if (typeId === HSIconType.mark) {
        draft.showTitle = 1;
      }
    });
    reAddEditingHotspot();
  };

  return (
    <Collapse title="图标设置">
      <Dropdown
        items={items}
        className="mb-20"
        selected={icon}
        placeholder={items[0].name}
        onChange={(id) => {
          setIcon(id);
          onChange(id);
          if (id !== 'none') {
            handleIconTypeChange(id);
          }
        }}
      />
      {icon !== undefined && icon === HSIconType.system && (
        <IconSettingSystem />
      )}
      {icon !== undefined && icon === HSIconType.mark && <IconSettingMark />}
      {icon !== undefined && icon === HSIconType.image && <IconSettingImage />}
      {icon !== undefined && icon === HSIconType.seqFrame && (
        <IconSettingSeqFrame />
      )}
      {icon !== undefined && icon === HSIconType.video && <IconSettingVideo />}
      {icon !== undefined && icon === HSIconType.polygon && (
        <IconSettingPolygon />
      )}
    </Collapse>
  );
}

export default IconBatchSetting;
